export const UCDP_OVERRIDE_FORM = {
	reasonCode: {
		DataType: 'Selector',
		DisplayText: 'Reason Code',
		Name: 'reasonCode',
		UIControl: 'Dropdown',
		options: [],
		UIOptions: {
			ShowFilter: true
		},
		UIEvents: {
			onChange: ($event: any, model: any, formGroup: any, extraData: any) => {
				formGroup.get('commentRequired')?.setValue(extraData.UIOptions.SelectedValue.commentRequired);
				formGroup.get('comment')?.updateValueAndValidity();
			}
		}
	},
	commentRequired: {
		DataType: 'Boolean',
		DisplayText: ' ',
		Name: 'commentRequired',
		required: false,
		hidden: true
	},
	comment: {
		DataType: 'Text',
		DisplayText: 'Comments',
		Name: 'comment',
		isRequired: function (control, jsonModelService: any) {
			const controlValue = jsonModelService.FindValue('commentRequired');
			return jsonModelService.IsEmpty() && controlValue === true;
		}
	}
};
